import React, { Component } from "react";

export class MetaPropertiesTableStatic extends Component {
  // componentDidMount(){
  //     console.log(this.props.statProps)
  // }

  render() {
    return (
      <div>
        <table className="table table-sm table-responsive">
          <thead>
            <tr>
              <th>Property</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {this.props.statProps.map((propName, index) => {
              var propValue = "";
              for (let i = 0; i < this.props.propertyValues.length; i++) {
                if (this.props.propertyValues[i].displayName == propName) {
                  propValue = this.props.propertyValues[i].displayValue;
                  break;
                }
              }
              if (propValue != "") {
                return (
                  <tr key={index}>
                    <td>{propName}</td>
                    <td>{propValue}</td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default MetaPropertiesTableStatic;
